import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollY
  } = useScroll();
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 800px (adjust as needed)
      setIsVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} exit={{
    y: 100,
    opacity: 0
  }} transition={{
    duration: 0.3,
    ease: 'easeOut'
  }} className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl p-4 md:hidden" data-id="element-122">
      <motion.a href="https://stresslessdogs.nl/mc-communiceren" whileTap={{
      scale: 0.98
    }} className="flex w-full bg-[#2563EB] text-white font-semibold text-base py-4 px-6 rounded-lg shadow-md active:bg-blue-700 transition-colors items-center justify-center" data-id="element-123">
        Bekijk wanneer het volgende webinar is
        <ArrowRight className="ml-2" size={18} data-id="element-124" />
      </motion.a>
    </motion.div>;
}